<div class="nav vertical">
  <app-inquiries-left-bar-view *ngIf="isInquiriesView"></app-inquiries-left-bar-view>
  <app-documents-left-bar-view *ngIf="isDocumentsView"></app-documents-left-bar-view>
  <app-generic-left-bar-view
    *ngIf="!isInquiriesView && !isDocumentsView"
    [navigation]="navigation"
  ></app-generic-left-bar-view>
</div>
